// @ts-nocheck
import { Card, CardContent, CardHeader, CardTitle } from 'shared/ui/card'
import { Button } from 'shared/ui/button'
import {
  Building2,
  UserPlus,
  FileUser,
  Settings,
  Shield,
  Database,
  Activity,
  GitBranch,
  Layout,
  Key,
  MapPin,
  Cloud,
  Mail,
  MailPlus,
  BarChart3,
  UserCheck,
  Cog
} from 'lucide-react'

interface AdminMenuProps {
  currentUser: any
  onNavigate: (page: string) => void
}

const adminModules = [
  {
    id: 'create-user-account',
    title: 'Create User Account',
    description: 'สร้างและจัดการบัญชีผู้ใช้งานใหม่',
    icon: UserPlus,
    color: 'bg-blue-500',
    category: 'User Management'
  },
  {
    id: 'contractor-management',
    title: 'Contractor Management',
    description: 'จัดการข้อมูลบริษัทผู้รับเหมาและบุคลากรภายนอก',
    icon: FileUser,
    color: 'bg-green-500',
    category: 'User Management'
  },
  {
    id: 'system-configuration',
    title: 'System Configuration',
    description: 'กำหนดชื่อระบบ โลโก้ favicon และข้อมูลพื้นฐานของแพลตฟอร์ม',
    icon: Cog,
    color: 'bg-slate-600',
    category: 'System Configuration'
  },
  {
    id: 'site-configuration',
    title: 'Site Configuration',
    description: 'ตั้งค่าไซต์งานและรายละเอียดพื้นที่ให้ถูกต้อง',
    icon: Settings,
    color: 'bg-indigo-500',
    category: 'System Configuration'
  },
  {
    id: 'workflow-configuration',
    title: 'Workflow Configuration',
    description: 'กำหนดขั้นตอนการอนุมัติสำหรับแต่ละประเภทงาน',
    icon: GitBranch,
    color: 'bg-rose-500',
    category: 'System Configuration'
  },
  {
    id: 'dynamic-form-configuration',
    title: 'Dynamic Form Configuration',
    description: 'ออกแบบฟอร์มและฟิลด์ข้อมูลตามประเภท Permit',
    icon: Layout,
    color: 'bg-violet-500',
    category: 'System Configuration'
  },
  {
    id: 'email-configuration',
    title: 'Email Configuration',
    description: 'Manage SMTP and base URL per environment',
    icon: Mail,
    color: 'bg-amber-500',
    category: 'System Configuration'
  },
  {
    id: 'email-template-configuration',
    title: 'Email Template Configuration',
    description: 'Manage email subject and body templates per tenant',
    icon: MailPlus,
    color: 'bg-indigo-500',
    category: 'System Configuration'
  },
  {
    id: 'permit-delegation-configuration',
    title: 'Permit Delegation Configuration',
    description: 'จัดการการมอบหมายสิทธิ์อนุมัติแทนของผู้ใช้งานในแต่ละ tenant',
    icon: UserCheck,
    color: 'bg-emerald-500',
    category: 'System Configuration'
  },
  {
    id: 'dynamic-report-configuration',
    title: 'Dynamic Report Configuration',
    description: 'Manage dynamic report templates and data source settings',
    icon: BarChart3,
    color: 'bg-fuchsia-500',
    category: 'System Configuration'
  },
  {
    id: 'active-directory-configuration',
    title: 'Active Directory Configuration',
    description: 'ตั้งค่าการเชื่อมต่อ AD และการยืนยันตัวตน',
    icon: Key,
    color: 'bg-blue-500',
    category: 'User Management'
  },
  {
    id: 'azure-ad-configuration',
    title: 'Azure AD Configuration',
    description: 'ตั้งค่าการเชื่อมต่อ Azure AD สำหรับการยืนยันตัวตน',
    icon: Cloud,
    color: 'bg-sky-500',
    category: 'User Management'
  },
  {
    id: 'company-master',
    title: 'Company Master',
    description: 'เก็บข้อมูลบริษัทและคู่ค้าหลักของระบบ',
    icon: Building2,
    color: 'bg-orange-500',
    category: 'Master Data'
  },
  {
    id: 'area-master',
    title: 'Area Master',
    description: 'จัดการข้อมูลพื้นที่และโซนการทำงาน',
    icon: Database,
    color: 'bg-cyan-500',
    category: 'Master Data'
  },
  {
    id: 'plot-plan-master',
    title: 'Plot Plan Master',
    description: 'อัปโหลดแผนผังพื้นที่สำหรับเลือกใช้ในใบ Permit',
    icon: MapPin,
    color: 'bg-emerald-500',
    category: 'Master Data'
  },
  {
    id: 'role-master',
    title: 'Role Master',
    description: 'สร้างและจัดการ Role พร้อมเปิด/ปิดใช้งาน',
    icon: Shield,
    color: 'bg-slate-500',
    category: 'Master Data'
  },
  {
    id: 'menu-master',
    title: 'Menu Master',
    description: 'จัดการรายการเมนู/ลิงก์สำหรับระบบ',
    icon: Settings,
    color: 'bg-slate-500',
    category: 'Master Data'
  },
  {
    id: 'role-menu-mapping',
    title: 'Role-Menu Mapping',
    description: 'กำหนดเมนูที่แต่ละ Role ใช้งานได้',
    icon: Shield,
    color: 'bg-indigo-500',
    category: 'Master Data'
  },
  {
    id: 'role-user-mapping',
    title: 'User-Role Mapping',
    description: 'กำหนด Role ให้ผู้ใช้ (ใช้ UserId)',
    icon: Shield,
    color: 'bg-blue-500',
    category: 'User Management'
  }
]

const categoryGroups = adminModules.reduce((groups, module) => {
  const category = module.category
  if (!groups[category]) {
    groups[category] = []
  }
  groups[category].push(module)
  return groups
}, {} as Record<string, typeof adminModules>)

export function AdminMenu({ currentUser, onNavigate }: AdminMenuProps) {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Administration</h1>
          <p className="text-gray-600 mt-1">
            เครื่องมือสำหรับบริหารจัดการระบบและการตั้งค่า
          </p>
        </div>
        <div className="text-right">
          <p className="text-sm text-gray-500">
            Logged in as: <span className="font-medium">{currentUser?.name}</span>
          </p>
          <p className="text-xs text-gray-400">Role: {currentUser?.role || 'Admin'}</p>
        </div>
      </div>

      {Object.entries(categoryGroups).map(([category, modules]) => (
        <div key={category} className="space-y-4">
          <div className="flex items-center space-x-2">
            <Settings className="h-5 w-5 text-gray-500" />
            <h2 className="text-xl font-semibold text-gray-800">{category}</h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {modules.map((module) => {
              const Icon = module.icon

              return (
                <Card
                  key={module.id}
                  className="hover:shadow-lg transition-all duration-200 cursor-pointer group hover:scale-105"
                  onClick={() => onNavigate(module.id)}
                >
                  <CardHeader className="pb-3">
                    <div className="flex items-start justify-between">
                      <div className={`${module.color} p-2 rounded-lg`}>
                        <Icon className="h-5 w-5 text-white" />
                      </div>
                    </div>
                    <CardTitle className="text-lg group-hover:text-blue-600 transition-colors">
                      {module.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="pt-0">
                    <p className="text-sm text-gray-600 mb-4">
                      {module.description}
                    </p>
                    <Button
                      variant="outline"
                      size="sm"
                      className="w-full group-hover:bg-blue-50 group-hover:border-blue-200 transition-colors"
                    >
                      เข้าใช้งาน
                    </Button>
                  </CardContent>
                </Card>
              )
            })}
          </div>
        </div>
      ))}

      <Card className="bg-gray-50">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="bg-green-500 p-2 rounded-lg">
                <Activity className="h-5 w-5 text-white" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">System Status</h3>
                <p className="text-sm text-gray-600">ระบบพร้อมใช้งาน</p>
              </div>
            </div>
            <div className="text-right">
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-green-500 rounded-full" />
                <span className="text-sm text-gray-500">Online</span>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
